module.exports = __webpack_public_path__ + "img/purple-bullet.d1304791.svg";